import React from 'react';
import { X, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const pains = ['Domingos perdidos buscando ejercicios de MRUV o circuitos eléctricos que se vean bien al imprimir.', 'Clases desconectadas porque no tienes una secuencia clara entre lo que ven en 1.º y lo que necesitan en 6.º.', 'La Feria de Ciencias que se acerca y no tienes ni un proyecto armado, ni los materiales, ni la guía para el jurado.', 'El estrés del cierre de cada etapa: horas redactando exámenes distintos para que nadie se copie y notas para todos los alumnos.', 'Los alumnos que te preguntan "¿profe, esto para qué sirve?" y tú no tienes un ejemplo cotidiano listo para responder.'];
export function PainPoints() {
  return <section className="py-8 md:py-20 px-4 bg-sky-200/50" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-slate-900 mb-4 md:mb-12" data-id="element-126">
          ¿Te suena familiar?
        </motion.h2>

        <div className="space-y-3 mb-6 md:mb-16" data-id="element-127">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 bg-white/40 p-4 md:p-5 rounded-2xl border border-white/60 shadow-sm" data-id="element-128">
              <div className="mt-1 bg-red-500/10 p-1 rounded-lg" data-id="element-129">
                <X size={18} className="text-red-600 stroke-[3px]" data-id="element-130" />
              </div>
              <p className="text-slate-800 font-bold text-sm md:text-lg leading-tight" data-id="element-131">
                {pain}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-blue-600 p-8 md:p-10 rounded-[2.5rem] text-center shadow-2xl shadow-blue-900/20 relative overflow-hidden" data-id="element-132">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 blur-2xl" data-id="element-133" />

          <div className="relative z-10" data-id="element-134">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 rounded-2xl mb-6" data-id="element-135">
              <CheckCircle2 className="text-white w-8 h-8" data-id="element-136" />
            </div>
            <h3 className="text-2xl md:text-3xl font-black text-white mb-4 leading-tight" data-id="element-137">
              Con el Mega Pack de Física, <br className="hidden md:block" data-id="element-138" />
              todo eso se termina.
            </h3>
            <p className="text-blue-100 font-bold text-lg md:text-xl" data-id="element-139">
              Tienes el año resuelto. Literalmente.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}